<template>
  <!-- Table Container Card -->
  <div>
    <!-- <b-card
        v-if="pfiOnboardingEmail && !showSearchEmail"
        no-body
      >
        <div class="m-5">
          <div class="mb-2 text-center">
            <h2 class="">Expression of Interest Request<br>
              (Financial Institution)</h2>
          </div>

          <h5 class="section-label mb-2 text-center">
            Please provide your company email address (personal emails are not allowed)
          </h5>
          <b-row class="d-flex justify-content-center">
            <b-col md="6">
              <validation-observer ref="onboardingInitialRules">
                <b-form>
                  <b-col
                    md="12"
                  >
                    <InputField
                      id="email-address"
                      v-model="userFormData.email"
                      label="Email Address"
                      placeholder="Enter your email address"
                      type="text"
                      error-name="Email Address"
                      rules="required|checkBusinessEmail|isEmailAddress"
                      for="email"
                    />
                  </b-col>
                  <b-row class="d-flex justify-content-center text-center">
                    <b-col class="mt-3">
                      <Button
                        label="Continue"
                        size="md"
                        @click="handleOnboardingInitial"
                      />
                    </b-col>
                  </b-row>
                </b-form>
              </validation-observer>
            </b-col>
          </b-row>
        </div>
      </b-card> -->
    <div
      v-if="pfiOnboardingEmail"
      class="col-6 d-flex align-items-center justify-content-lg-start"
    >
      <Button
        v-if="actionType === 'edit' || actionType === 'view' && showBackButton"
        label="Back"
        size="md"
        icon="ArrowLeftIcon"
        show-icon
        class="mb-1"
        @click="backNavigationAction"
      />
      <Button
        v-if="actionType === 'add' && showBackButton"
        label="Back"
        size="md"
        icon="ArrowLeftIcon"
        show-icon
        class="mb-1"
        @click="backNavigationResume"
      />
    </div>
    <form-wizard
      ref="pfiOboardingFormRef"
      :title="null"
      :subtitle="null"
      layout="vertical"
      back-button-text="Previous"
      :next-button-text="actionType=== 'add' ? 'Save and Continue' : 'Next'"
      class="wizard-vertical mb-3"
    >

      <!-- Background Information tab -->
      <tab-content
        title="Background Information"
        :before-change="handleBackgroundInformation"
      >
        <validation-observer ref="backgroundInfoRules">
          <b-form>
            <h5 class="section-label mb-2">
              Background Information & Board/Management Capacity
            </h5>
            <b-row class="match-height">
              <b-col md="6">
                <InputField
                  id="name-institution"
                  v-model="backgroundInfoFormData.institutionName"
                  label="Name of Institution"
                  placeholder="Enter institution name"
                  type="text"
                  error-name="Name of Institution"
                  rules="required"
                  :readonly="isReadonly"
                />
              </b-col>
              <b-col md="6">
                <InputField
                  id="email-institution"
                  v-model="backgroundInfoFormData.institutionEmail"
                  label="Email of Institution"
                  placeholder="Enter institution email"
                  type="text"
                  error-name="Email of Institution"
                  rules="required|isEmailAddress"
                  :readonly="isReadonly"
                />
              </b-col>
              <b-col md="6">
                <InputField
                  id="contact-fullname"
                  v-model="backgroundInfoFormData.fullName"
                  label="Contact Fullname"
                  placeholder="Enter contact fullname"
                  type="text"
                  error-name="Contact Fullname"
                  rules="required"
                  :readonly="isReadonly"
                />
              </b-col>
              <b-col md="6">
                <InputField
                  id="contact-email-addree"
                  v-model="backgroundInfoFormData.contactEmailAddress"
                  label="Contact Email Address"
                  placeholder="Enter contact email address"
                  type="text"
                  error-name="Contact Email Address"
                  rules="required"
                  readonly
                />
              </b-col>
              <b-col md="6">
                <InputField
                  id="contact-phone-number"
                  v-model="backgroundInfoFormData.contactPhoneNumber"
                  label="Contact Phone Number"
                  placeholder="Enter contact phone number"
                  type="text"
                  error-name="Contact Phone Number"
                  rules="required|phoneNumber"
                  :readonly="isReadonly"
                />
              </b-col>
              <b-col md="6">
                <InputField
                  id="address-institution"
                  v-model="backgroundInfoFormData.institutionAddress"
                  label="Address of Institution"
                  placeholder="Enter street number and name"
                  type="text"
                  error-name="Address of Institution"
                  rules="required"
                  :readonly="isReadonly"
                />
              </b-col>
              <b-col md="6">
                <InputField
                  id="city-institution"
                  v-model="backgroundInfoFormData.city"
                  label="City of Institution"
                  placeholder="Enter city"
                  type="text"
                  error-name="City of Institution"
                  rules="required"
                  :readonly="isReadonly"
                />
              </b-col>

              <b-col md="6">
                <SelectField
                  id="state-institution"
                  v-model="backgroundInfoFormData.state"
                  label="State of Institution"
                  :options="stateOptions"
                  :reduce="option => option"
                  error-name="State of Institution"
                  rules="required"
                  :readonly="isReadonly"
                  item="label"
                  placeholder="Select"
                  :set-selected="getLGAByState"
                />
              </b-col>
              <b-col md="6">
                <SelectField
                  id="lga-institution"
                  v-model="backgroundInfoFormData.localGovernmentArea"
                  label="LGA of Institution"
                  :options="lgaOptions"
                  :reduce="option => option"
                  error-name="LGA of Institution"
                  rules="required"
                  :readonly="isReadonly"
                  item="label"
                  placeholder="Select"
                />
              </b-col>

              <b-col md="6">
                <InputNumberField
                  id="last-name"
                  v-model="backgroundInfoFormData.shareholdersFund"
                  label="What is your Shareholder's Fund(unencumbered by losses)"
                  placeholder="Enter shareholder's fund"
                  type="text"
                  error-name="Shareholder's Fund"
                  rules="required"
                  :readonly="isReadonly"
                />
              </b-col>
            </b-row>
            <b-row>
              <b-col md="6">
                <DatePickerField
                  id="operating-license-issued"
                  v-model="backgroundInfoFormData.operatingLicenseIssueDate"
                  :min-date="new Date()"
                  label="When was your operating license issued by CBN?"
                  rules="required"
                  error-name="Operating license issued"
                  :config="datePickerConfig"
                  placeholder="When was your operating license issued by CBN?"
                  :disabled="isReadonly"
                  vid="maxDate"
                />
              </b-col>
            </b-row>
            <b-row class="match-height">
              <b-col md="6">
                <InputField
                  id="license-number"
                  v-model="backgroundInfoFormData.licenseNumber"
                  label="License Number"
                  placeholder="Enter license number"
                  type="text"
                  error-name="License Number"
                  rules="required"
                  :readonly="isReadonly"
                />
              </b-col>
            </b-row>
            <b-row>
              <b-col md="6">
                <DatePickerField
                  id="operating-commencement-date"
                  v-model="backgroundInfoFormData.operationCommencementDate"
                  :min-date="new Date()"
                  label="What date did you commence operation?"
                  rules="required|isCommencementDateGreater:@maxDate"
                  error-name="Operating Commencement Date"
                  :config="datePickerConfig"
                  placeholder="What date did you commence operation?"
                  :disabled="isReadonly"
                />
              </b-col>
            </b-row>
            <b-row>
              <b-col md="6">
                <SelectField
                  id="fi-types"
                  v-model="backgroundInfoFormData.financialInstitutionType"
                  label="What type of FI is your institution?"
                  :options="fiTypesOptions"
                  :reduce="option => option.value"
                  error-name="What type of FI is your institution?"
                  rules="required"
                  :readonly="isReadonly"
                  item="label"
                  placeholder="Select Financial Institution Type"
                />
              </b-col>
              <b-col
                v-if="backgroundInfoFormData.financialInstitutionType === 'CommercialBank'"
                md="6"
              >
                <SelectField
                  id="commercial-bank-types"
                  v-model="backgroundInfoFormData.commercialBankType"
                  :label="`What class of ${addSpaceToString(backgroundInfoFormData.financialInstitutionType)} are you, based on CBN classification?`"
                  :options="classOfCommercialBanksOptions"
                  :reduce="option => option.value"
                  error-name="Commercial Bank Type"
                  rules="required"
                  :readonly="isReadonly"
                  item="label"
                  :placeholder="`Select ${addSpaceToString(backgroundInfoFormData.financialInstitutionType)} Type`"
                />
              </b-col>
              <b-col
                v-if="backgroundInfoFormData.financialInstitutionType === 'MicroFinanceBank'"
                md="6"
              >
                <SelectField
                  id="mfb-types"
                  v-model="backgroundInfoFormData.microFinanceBankType"
                  :label="`What class of ${addSpaceToString(backgroundInfoFormData.financialInstitutionType)} are you, based on CBN classification?`"
                  :options="classOfMFBOptions"
                  :reduce="option => option.value"
                  error-name="Micro Finance Bank Type"
                  rules="required"
                  :readonly="isReadonly"
                  item="label"
                  :placeholder="`Select ${addSpaceToString(backgroundInfoFormData.financialInstitutionType)} Type`"
                />
              </b-col>
              <b-col md="6">
                <InputField
                  id="branch-count"
                  v-model="backgroundInfoFormData.branchCount"
                  label="How many branches do you currently have?(if branchless, enter 0)"
                  placeholder="Enter count of branches"
                  type="number"
                  error-name="Branch Count"
                  rules="required"
                  :readonly="isReadonly"
                />
              </b-col>
              <b-col md="6">
                <InputField
                  id="credit-product-outlet-count"
                  v-model="backgroundInfoFormData.creditProductOutletCount"
                  label="How many of these branches are used as outlets for selling consumer credit products?"
                  placeholder="Enter number of outlet"
                  type="number"
                  error-name="Products Outlet Number"
                  rules="required"
                  :readonly="isReadonly"
                />
              </b-col>
              <b-col md="6">
                <SelectField
                  id="regulatory-execption"
                  v-model="backgroundInfoFormData.hasRegulatoryExceptions"
                  label="Any major regulatory exception(s) on corporate governance on your board in the last two years?"
                  :options="yesNoOptions"
                  :reduce="option => option.value"
                  error-name="Regulatory Execption"
                  rules="required"
                  :readonly="isReadonly"
                  item="label"
                  placeholder="Select"
                />
              </b-col>
              <b-col
                v-if="backgroundInfoFormData.hasRegulatoryExceptions === 'Yes'"
                md="6"
              >
                <InputField
                  id="regulatory-execption-details"
                  v-model="backgroundInfoFormData.regulatoryExceptions"
                  label="Please provide details of the exception(s) and resolution"
                  placeholder="Enter regulatory execption details"
                  type="text"
                  error-name="Regulatory Execption Details"
                  rules="required"
                  :readonly="isReadonly"
                />
              </b-col>
              <b-col md="6">
                <SelectField
                  id="approved-risk-management"
                  v-model="backgroundInfoFormData.hasRiskManagementFramework"
                  label="Do you have a well documented Board approved risk management framework, polices and procedures for managing all types of risks?"
                  :options="yesNoOptions"
                  :reduce="option => option.value"
                  error-name="Approved Risk Management"
                  rules="required"
                  :readonly="isReadonly"
                  item="label"
                  placeholder="Select"
                />
              </b-col>
              <b-col md="6">
                <SelectField
                  id="credit-relationship"
                  v-model="backgroundInfoFormData.hasCreditBureauRelationships"
                  label="Do you have relationships with Credit Bureaus to check the credit status of prospective borrowers?"
                  :options="yesNoOptions"
                  :reduce="option => option.value"
                  error-name="Credit Relationship"
                  rules="required"
                  :readonly="isReadonly"
                  item="label"
                  placeholder="Select"
                />
              </b-col>
              <b-col
                v-if="backgroundInfoFormData.hasCreditBureauRelationships === 'Yes'"
                md="6"
              >
                <SelectField
                  id="credit-relationship-number"
                  v-model="backgroundInfoFormData.creditBureauRelationshipsCount"
                  label="If yes, how many?"
                  :options="creditRelationshipNumberOptions"
                  :reduce="option => option.value"
                  error-name="Credit Relationship Number"
                  rules="required"
                  :readonly="isReadonly"
                  item="label"
                  placeholder="Select"
                  :set-selected="resetCreditBureau"
                />
              </b-col>
              <b-col
                v-if="backgroundInfoFormData.creditBureauRelationshipsCount"
                md="6"
              >
                <SelectField
                  id="credit-bureau"
                  v-model="backgroundInfoFormData.creditBureaus"
                  label="Please provide the name(s) of the Credit Bureau(s)"
                  :options="creditBureauOptions"
                  :reduce="option => option.value"
                  error-name="Credit Bureau(s)"
                  rules="required"
                  :readonly="isReadonly"
                  item="label"
                  multiple
                  placeholder="Select"
                  :set-selected="limitSelection"
                />
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <b-col
                  md="12"
                  class="custom-label-first"
                >
                  <p>Which of our two credit products would you prefer to access?</p>
                  <p class="custom-header-label">
                    1: Wholesale lending
                  </p>
                  <p class="custom-label">
                    CREDICORP lends you (the FI) its funds at good rates (MPR or slightly concessionary) and you lend to Nigerians seeking all kinds of consumer credit. You bear the credit risk.
                    <!-- We lend you OUR money at a good rates, and you lend to Nigerians seeking for any type of customer credit -->
                  </p>
                  <p class="custom-header-label">
                    2: Credit guarantees
                  </p>
                  <p class="custom-label-last">
                    You lend Nigerians your funds and CREDICORP shares the credit risk partially (say 50%) with you. Guarantees apply for a broad range of consumer credit (e.g locally-manufactured, targeted inducstries, etc) but not all.
                    <!-- You lend Nigerians YOUR money to buy made-in-Nigeria goods, and we share the credit risks partially with you. -->
                  </p>
                </b-col>
                <SelectField
                  id="credit-products"
                  v-model="backgroundInfoFormData.preferredCreditProducts"
                  label=""
                  :options="creditProductTypeOptions"
                  :reduce="option => option.value"
                  error-name="Credit Products"
                  rules="required"
                  :readonly="isReadonly"
                  item="label"
                  placeholder="Select credit product"
                />
              </b-col>
            </b-row>
            <b-row>
              <b-col
                md="12"
                class="mb-1 custom-label-last"
              >
                What is the total amount of consumer credit extended by your institution in the last consecutive years?
              </b-col>
              <b-col md="6">
                <ValidationObserver>
                  <InputNumberField
                    id="amount-2021"
                    v-model="backgroundInfoFormData.creditExtendedAmountFourYearsAgo"
                    :label="`${lastFourYears} Amount`"
                    :placeholder="`Enter amount for ${lastFourYears}`"
                    type="text"
                    :error-name="`${lastFourYears} Amount`"
                    rules="required"
                    :readonly="isReadonly"
                  />
                </ValidationObserver>
              </b-col>
              <b-col md="6">
                <ValidationObserver>
                  <InputNumberField
                    id="amount-2022"
                    v-model="backgroundInfoFormData.creditExtendedAmountThreeYearsAgo"
                    :label="`${lastThreeYears} Amount`"
                    :placeholder="`Enter amount for ${lastThreeYears}`"
                    type="text"
                    :error-name="`${lastThreeYears} Amount`"
                    rules="required"
                    :readonly="isReadonly"
                  />
                </ValidationObserver>
              </b-col>
              <b-col md="6">
                <ValidationObserver>
                  <InputNumberField
                    id="amount-2023"
                    v-model="backgroundInfoFormData.creditExtendedAmountTwoYearsAgo"
                    :label="`${lastTwoYears} Amount`"
                    :placeholder="`Enter amount for ${lastTwoYears}`"
                    type="text"
                    :error-name="`${lastTwoYears} Amount`"
                    rules="required"
                    :readonly="isReadonly"
                  />
                </ValidationObserver>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="6">
                <SelectField
                  id="product-tenor"
                  v-model="backgroundInfoFormData.averageProductTenor"
                  label="What is the average tenor of the products (in Years)?"
                  :options="averageProductTenorOptions"
                  :reduce="option => option.value"
                  error-name="Product Tenor"
                  rules="required"
                  :readonly="isReadonly"
                  item="label"
                  placeholder="Select average product tenor"
                />
              </b-col>

              <b-col md="6">
                <InputField
                  id="average-interest-rate"
                  v-model="backgroundInfoFormData.averageInterestRate"
                  label="What is the average interest rate per annum offered your consumer credit products? (per annum) %"
                  placeholder="Enter average interest rate"
                  type="number"
                  error-name="Average Interest Rate"
                  rules="required|max-value"
                  :readonly="isReadonly"
                />
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </tab-content>

      <!-- Contact Details tab -->
      <tab-content
        title="Profitability Requirements"
        :before-change="validateProfitabilityRequirement"
      >
        <validation-observer ref="profitabilityRequirementRules">
          <b-form>
            <h5 class="section-label mb-2">
              Profitability $ Other Prudential Requirements
            </h5>
            <b-row class="match-height">
              <b-col
                md="12"
                class="mb-1 mt-1 custom-label-last"
              >
                Please provide the PBT for the last three consecutive years?
              </b-col>
              <b-col md="6">
                <ValidationObserver>
                  <InputNumberField
                    id="figures-2021"
                    v-model="profitabilityRequirementFormData.pbtFigureFourYearsAgo"
                    :label="`${lastFourYears}  Figures (₦)`"
                    :placeholder="`Enter figures for ${lastFourYears}`"
                    type="text"
                    :error-name="`${lastFourYears} Figures`"
                    rules="required"
                    :readonly="isReadonly"
                  />
                </ValidationObserver>
              </b-col>
              <b-col md="6">
                <ValidationObserver>
                  <InputNumberField
                    id="figures-2022"
                    v-model="profitabilityRequirementFormData.pbtFigureThreeYearsAgo"
                    :label="`${lastThreeYears} Figures (₦)`"
                    :placeholder="`Enter figures for ${lastThreeYears}`"
                    type="text"
                    :error-name="`${lastThreeYears} Figures`"
                    rules="required"
                    :readonly="isReadonly"
                  />
                </ValidationObserver>
              </b-col>
              <b-col md="6">
                <ValidationObserver>
                  <InputNumberField
                    id="figures-2023"
                    v-model="profitabilityRequirementFormData.pbtFigureTwoYearsAgo"
                    :label="`${lastTwoYears} Figures (₦)`"
                    :placeholder="`Enter figures for ${lastTwoYears}`"
                    type="text"
                    :error-name="`${lastTwoYears} Figures`"
                    rules="required"
                    :readonly="isReadonly"
                  />
                </ValidationObserver>
              </b-col>
            </b-row>
            <b-row class="match-height">
              <b-col
                md="12"
                class="mb-1 mt-1 custom-label-last"
              >
                Capital Adequacy Ratio of your bank in the last three consecutive years?
              </b-col>
              <b-col md="6">
                <ValidationObserver>
                  <InputField
                    id="capital-ratio-2021"
                    v-model="profitabilityRequirementFormData.capitalAdequacyRatioFourYearsAgo"
                    :label="`${lastFourYears} Ratio (%)`"
                    :placeholder="`Enter ratio for ${lastFourYears}`"
                    type="number"
                    :error-name="`${lastFourYears} Ratio`"
                    rules="required|max-value"
                    :readonly="isReadonly"
                  />
                </ValidationObserver>
              </b-col>
              <b-col md="6">
                <ValidationObserver>
                  <InputField
                    id="capital-ratio-2022"
                    v-model="profitabilityRequirementFormData.capitalAdequacyRatioThreeYearsAgo"
                    :label="`${lastThreeYears} Ratio (%)`"
                    :placeholder="`Enter ratio for ${lastThreeYears}`"
                    type="number"
                    :error-name="`${lastThreeYears} Ratio`"
                    rules="required|max-value"
                    :readonly="isReadonly"
                  />
                </ValidationObserver>
              </b-col>
              <b-col md="6">
                <ValidationObserver>
                  <InputField
                    id="capital-ratio-2023"
                    v-model="profitabilityRequirementFormData.capitalAdequacyRatioTwoYearsAgo"
                    :label="`${lastTwoYears} Ratio (%)`"
                    :placeholder="`Enter ratio for ${lastTwoYears}`"
                    type="number"
                    :error-name="`${lastTwoYears} Ratio`"
                    rules="required|max-value"
                    :readonly="isReadonly"
                  />
                </ValidationObserver>
              </b-col>
            </b-row>
            <b-row class="match-height">
              <b-col
                md="12"
                class="mb-1 mt-1 custom-label-last"
              >
                Liquidity Ratio of your bank in the last three consecutive years?
              </b-col>
              <b-col md="6">
                <ValidationObserver>
                  <InputField
                    id="liquidity-ratio-2021"
                    v-model="profitabilityRequirementFormData.liquidityRatioFourYearsAgo"
                    :label="`${lastFourYears} Ratio (%)`"
                    :placeholder="`Enter ratio for ${lastFourYears}`"
                    type="number"
                    :error-name="`${lastFourYears} Ratio`"
                    rules="required|max-value"
                    :readonly="isReadonly"
                  />
                </ValidationObserver>
              </b-col>
              <b-col md="6">
                <ValidationObserver>
                  <InputField
                    id="liquidity-ratio-2022"
                    v-model="profitabilityRequirementFormData.liquidityRatioThreeYearsAgo"
                    :label="`${lastThreeYears} Ratio (%)`"
                    :placeholder="`Enter ratio for ${lastThreeYears}`"
                    type="number"
                    :error-name="`${lastThreeYears} Ratio`"
                    rules="required|max-value"
                    :readonly="isReadonly"
                  />
                </ValidationObserver>
              </b-col>
              <b-col md="6">
                <ValidationObserver>
                  <InputField
                    id="liquidity-ratio-2023"
                    v-model="profitabilityRequirementFormData.liquidityRatioTwoYearsAgo"
                    :label="`${lastTwoYears} Ratio (%)`"
                    :placeholder="`Enter ratio for ${lastTwoYears}`"
                    type="number"
                    :error-name="`${lastTwoYears} Ratio`"
                    rules="required|max-value"
                    :readonly="isReadonly"
                  />
                </ValidationObserver>
              </b-col>
            </b-row>
            <b-row class="match-height">
              <b-col
                md="12"
                class="mb-1 mt-1 custom-label-last"
              >
                What was the Non-Performing Loans (NPL) ratio % of your bank in the last three consecutive years?
              </b-col>
              <b-col md="6">
                <ValidationObserver>
                  <InputField
                    id="nonPerforming-ratio-2021"
                    v-model="profitabilityRequirementFormData.nplRatioFourYearsAgo"
                    :label="`${lastFourYears} Ratio (%)`"
                    :placeholder="`Enter ratio for ${lastFourYears}`"
                    type="number"
                    :error-name="`${lastFourYears} Ratio`"
                    rules="required|max-value"
                    :readonly="isReadonly"
                  />
                </ValidationObserver>
              </b-col>
              <b-col md="6">
                <ValidationObserver>
                  <InputField
                    id="nonPerforming-ratio-2022"
                    v-model="profitabilityRequirementFormData.nplRatioThreeYearsAgo"
                    :label="`${lastThreeYears} Ratio (%)`"
                    :placeholder="`Enter ratio for ${lastThreeYears}`"
                    type="number"
                    :error-name="`${lastThreeYears} Ratio`"
                    rules="required|max-value"
                    :readonly="isReadonly"
                  />
                </ValidationObserver>
              </b-col>
              <b-col md="6">
                <ValidationObserver>
                  <InputField
                    id="nonPerforming-ratio-2023"
                    v-model="profitabilityRequirementFormData.nplRatioTwoYearsAgo"
                    :label="`${lastTwoYears} Ratio (%)`"
                    :placeholder="`Enter ratio for ${lastTwoYears}`"
                    type="number"
                    :error-name="`${lastTwoYears} Ratio`"
                    rules="required|max-value"
                    :readonly="isReadonly"
                  />
                </ValidationObserver>
              </b-col>
            </b-row>
            <b-row class="match-height">
              <b-col
                md="12"
                class="mb-1 mt-1 custom-label-last"
              >
                Non-Performing Loans (NPL) ratio % of your bank's Consumer Credit portifolio in the last three consecutive years?
              </b-col>
              <b-col md="6">
                <InputField
                  id="nonPerformingCredit-ratio-2021"
                  v-model="profitabilityRequirementFormData.consumerCreditNplRatioFourYearsAgo"
                  :label="`${lastFourYears} Ratio (%)`"
                  :placeholder="`Enter ratio for ${lastFourYears}`"
                  type="number"
                  :error-name="`${lastFourYears} Ratio`"
                  rules="required|max-value"
                  :readonly="isReadonly"
                />
              </b-col>
              <b-col md="6">
                <InputField
                  id="nonPerformingCredit-ratio-2022"
                  v-model="profitabilityRequirementFormData.consumerCreditNplRatioThreeYearsAgo"
                  :label="`${lastThreeYears} Ratio (%)`"
                  :placeholder="`Enter ratio for ${lastThreeYears}`"
                  type="number"
                  :error-name="`${lastThreeYears} Ratio`"
                  rules="required|max-value"
                  :readonly="isReadonly"
                />
              </b-col>
              <b-col md="6">
                <InputField
                  id="nonPerformingCredit-ratio-2023"
                  v-model="profitabilityRequirementFormData.consumerCreditNplRatioTwoYearsAgo"
                  :label="`${lastTwoYears} Ratio (%)`"
                  :placeholder="`Enter ratio for ${lastTwoYears}`"
                  type="number"
                  :error-name="`${lastTwoYears} Ratio`"
                  rules="required|max-value"
                  :readonly="isReadonly"
                />
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </tab-content>

      <tab-content
        title="Risk Management Practices"
        :before-change="validateRiskManagementPractices"
      >
        <validation-observer ref="riskManagementPracticesRules">
          <b-form>
            <h5 class="section-label mb-2">
              Risk Management Practices
            </h5>
            <b-row class="match-height">
              <b-col
                md="12"
                class="custom-label"
              >
                Overall CBN/NDIC risk rating of your bank based on the last two consecutive routine examinations?
              </b-col>
              <b-col md="6">
                <ValidationObserver>
                  <SelectField
                    id="rating-year"
                    v-model="riskManagementFormData.rIskRatingLastTwoYears"
                    label="Year"
                    :options="yearsOptions"
                    :reduce="option => option.value"
                    error-name="Year"
                    rules="required"
                    :readonly="isReadonly"
                    item="label"
                    placeholder="Year"
                  />
                </ValidationObserver>
              </b-col>
              <b-col md="6">
                <ValidationObserver>
                  <SelectField
                    id="rating"
                    v-model="riskManagementFormData.rIskRatingValueLastTwoYears"
                    label="Rating"
                    :options="ratingOptions"
                    :reduce="option => option.value"
                    error-name="Rating"
                    rules="required"
                    :readonly="isReadonly"
                    item="label"
                    placeholder="Select"
                  />
                </ValidationObserver>
              </b-col>
              <b-col md="6">
                <SelectField
                  id="rating-year2"
                  v-model="riskManagementFormData.rIskRatingLastYear"
                  label="Year"
                  :options="yearsOptions"
                  :reduce="option => option.value"
                  error-name="Year"
                  rules="required"
                  :readonly="isReadonly"
                  item="label"
                  placeholder="Year"
                />
              </b-col>
              <b-col md="6">
                <SelectField
                  id="rating"
                  v-model="riskManagementFormData.rIskRatingValueLastYear"
                  label="Rating"
                  :options="ratingOptions"
                  :reduce="option => option.value"
                  error-name="Rating"
                  rules="required"
                  :readonly="isReadonly"
                  item="label"
                  placeholder="Select"
                />
              </b-col>

              <b-col md="6">
                <SelectField
                  id="risk-management-framework"
                  v-model="riskManagementFormData.hasRiskManagementFramework"
                  label="Do you have a well-documented risk management framework, polices and procedures for managing all types of risks?"
                  :options="yesNoOptions"
                  :reduce="option => option.value"
                  error-name="Risk Management Framework"
                  rules="required"
                  :readonly="isReadonly"
                  item="label"
                  placeholder="Select"
                />
              </b-col>
              <b-col md="6">
                <SelectField
                  id="risk-profile"
                  v-model="riskManagementFormData.riskReviewFrequency"
                  label="How frequently are they reviewed to take account of changes in the bank's risk profile and operating environment?"
                  :options="riskReviewFrequentOptions"
                  :reduce="option => option.value"
                  error-name="Risk Profile"
                  rules="required"
                  :readonly="isReadonly"
                  item="label"
                  placeholder="Select"
                />
              </b-col>
              <b-col md="6">
                <SelectField
                  id="risk-appetite-framework"
                  v-model="riskManagementFormData.hasRiskAppetiteFramework"
                  label="Does your bank have a Board approved risk appetite statement and risk appetite framework?"
                  :options="yesNoOptions"
                  :reduce="option => option.value"
                  error-name="Risk Appetite Framework"
                  rules="required"
                  :readonly="isReadonly"
                  item="label"
                  placeholder="Select"
                />
              </b-col>
              <b-col md="6">
                <SelectField
                  id="risk-appetite-profile"
                  v-model="riskManagementFormData.riskAppetiteDescription"
                  label="Describe your bank's risk appetite and risk profile"
                  :options="bankRiskAppetiteOptions"
                  :reduce="option => option.value"
                  error-name="Risk Appetite and Profile Description"
                  rules="required"
                  :readonly="isReadonly"
                  item="label"
                  placeholder="Select"
                />
              </b-col>
              <b-col md="6">
                <SelectField
                  id="risk-monitor-limits"
                  v-model="riskManagementFormData.hasRiskMonitoringMeasures"
                  label="Are they measures (limits and threshold) in place to monitor compliance with the bank's risk appetite?"
                  :options="yesNoOptions"
                  :reduce="option => option.value"
                  error-name="Risk Monitoring Measures"
                  rules="required"
                  :readonly="isReadonly"
                  item="label"
                  placeholder="Select"
                />
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </tab-content>

      <tab-content
        title="Regulatory Compliance"
        :before-change="validateRegulatoryCompliance"
      >
        <validation-observer ref="regulatoryComplianceRules">
          <b-form>
            <h5 class="section-label mb-2">
              Regulatory Compliance
            </h5>
            <b-row class="match-height">

              <b-col md="6">
                <SelectField
                  id="compliance-level"
                  v-model="regulatoryFormData.complianceLevel"
                  label="Describe the level of compliance of your bank with extant laws and regulations?"
                  :options="complianceLevelOptions"
                  :reduce="option => option.value"
                  error-name="Compliance Level"
                  rules="required"
                  :readonly="isReadonly"
                  item="label"
                  placeholder="Select level"
                />
              </b-col>
              <b-col md="6">
                <SelectField
                  id="regulations-breach"
                  v-model="regulatoryFormData.hasRegulatoryBreaches"
                  label="Any breach in regulations, involving payment of fines and panelties by your bank to regulators?"
                  :options="yesNoOptions"
                  :reduce="option => option.value"
                  error-name="Regulation Breach"
                  rules="required"
                  :readonly="isReadonly"
                  item="label"
                  placeholder="Select"
                />
              </b-col>
              <b-col md="6">
                <SelectField
                  id="approved-board"
                  v-model="regulatoryFormData.hasComplianceFramework"
                  label="Do you have in place a Board approved well-documented compliance framework, polices, programmes and plan?"
                  :options="yesNoOptions"
                  :reduce="option => option.value"
                  error-name="Approved Board"
                  rules="required"
                  :readonly="isReadonly"
                  item="label"
                  placeholder="Select"
                />
              </b-col>

              <b-col md="6">
                <SelectField
                  id="approved-board-anti-money-laundry"
                  v-model="regulatoryFormData.hasAmlCftPolicies"
                  label="Does your bank have in place a Board approved well-documented Anti-Money Laundry (AML) and Counter Financing Terrorism (CFT) polices, procedures?"
                  :options="yesNoOptions"
                  :reduce="option => option.value"
                  error-name="Approved Anti money Laundry"
                  rules="required"
                  :readonly="isReadonly"
                  item="label"
                  placeholder="Select"
                />
              </b-col>
              <b-col md="6">
                <SelectField
                  id="money-laundry-compliance-level"
                  v-model="regulatoryFormData.moneyLaunderingActComplianceLevel"
                  label="What is your level of compliance with the requiremnet of Money Laundering (Prohibition) Act 2011, (as amended), Terrorism Prevention Act 2011 (as amended) "
                  :options="moneyLaundryComplianceLevelOptions"
                  :reduce="option => option.value"
                  error-name="Money Laundry Compliance Level"
                  rules="required"
                  :readonly="isReadonly"
                  item="label"
                  placeholder="Select compliance level"
                />
              </b-col>

              <b-col md="6">
                <InputField
                  id="kyc-compliance"
                  v-model="regulatoryFormData.kycComplianceMeasures"
                  label="What measures does your bank put in place to ensure compliance with KYC requirements with CBN?"
                  placeholder="Enter measure"
                  type="text"
                  error-name="KYC Measures"
                  rules="required"
                  :readonly="isReadonly"
                />
              </b-col>

              <b-col md="6">
                <SelectField
                  id="nsbp-compliance-level"
                  v-model="regulatoryFormData.nsrpComplianceLevel"
                  label="What is the level of compliance of your bank to the CBN/Bankers Committee’s Nigerian Sustainable Banking Principles (NSBP)?"
                  :options="moneyLaundryComplianceLevelOptions"
                  :reduce="option => option.value"
                  error-name="NSBP Compliance Level"
                  rules="required"
                  :readonly="isReadonly"
                  item="label"
                  placeholder="Select compliance level"
                />
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </tab-content>

      <!-- Loan Servicing Account Details tab -->
      <tab-content
        title="Consumer Credit Sector"
      >
        <validation-observer ref="consumerCreditSectorRules">
          <b-form>
            <h5 class="section-label mb-2">
              Consumer Credit Sector
            </h5>
            <b-row class="match-height">
              <b-col md="6">
                <InputField
                  id="debt-service-ratio"
                  v-model="consumerCreditFormData.debtServiceRatio"
                  label="What is the average Debt Service Ratio on your consumer credit Products?"
                  placeholder="Enter debit service ratio"
                  type="number"
                  error-name="Debit Service Ratio"
                  rules="required"
                  :readonly="isReadonly"
                />
              </b-col>
              <b-col md="6">
                <InputField
                  id="credit-worthiness"
                  v-model="consumerCreditFormData.creditworthinessAssessmentMethod"
                  label="How does your institution assess the creditworthiness of borrowers applying for loans?"
                  placeholder="Enter how institution assess creditworthiness"
                  type="text"
                  error-name="Credit Worthiness"
                  rules="required"
                  :readonly="isReadonly"
                />
              </b-col>

              <b-col md="6">
                <SelectField
                  id="product-portifolio"
                  v-model="consumerCreditFormData.productSuccessRating"
                  label="How successful are the products (Total Loan Portifolio and NPL Ratio)?"
                  :options="successLevelOptions"
                  :reduce="option => option.value"
                  error-name="Product Portifolio"
                  rules="required"
                  :readonly="isReadonly"
                  item="label"
                  placeholder="Select success"
                />
              </b-col>
            </b-row>
            <b-row>
              <b-col
                md="12"
                class="mb-1 mt-1 custom-label-last"
              >
                What is the total number of consumer credit customers in your Bank in the last three consecutive years?
              </b-col>
              <b-col md="6">
                <ValidationObserver>
                  <InputNumberField
                    id="number-2021"
                    v-model="consumerCreditFormData.customerCountFourYearsAgo"
                    :label="`${lastFourYears} Number`"
                    :placeholder="`Enter credit for ${lastFourYears}`"
                    type="text"
                    :error-name="`${lastFourYears} Number`"
                    rules="required"
                    :readonly="isReadonly"
                  />
                </ValidationObserver>
              </b-col>
              <b-col md="6">
                <ValidationObserver>
                  <InputNumberField
                    id="number-2022"
                    v-model="consumerCreditFormData.customerCountThreeYearsAgo"
                    :label="`${lastThreeYears} Number`"
                    :placeholder="`Enter credit for ${lastThreeYears}`"
                    type="text"
                    :error-name="`${lastThreeYears} Number`"
                    rules="required"
                    :readonly="isReadonly"
                  />
                </ValidationObserver>
              </b-col>
              <b-col md="6">
                <ValidationObserver>
                  <InputNumberField
                    id="number-2023"
                    v-model="consumerCreditFormData.customerCountTwoYearsAgo"
                    :label="`${lastTwoYears} Number`"
                    :placeholder="`Enter credit for ${lastTwoYears}`"
                    type="text"
                    :error-name="`${lastTwoYears} Number`"
                    rules="required"
                    :readonly="isReadonly"
                  />
                </ValidationObserver>
              </b-col>
            </b-row>
            <b-row>
              <b-col
                md="12"
                class="mb-1 mt-1 custom-label-last"
              >
                What is the proportion of borrowing consumer credit customers to the total borrowing customers in your Bank in the last three consecutive years (%)?
              </b-col>
              <b-col md="6">
                <InputField
                  id="ratio-2021"
                  v-model="consumerCreditFormData.customerProportionFourYearsAgo"
                  :label="`${lastFourYears} (%)`"
                  placeholder="Enter rate"
                  type="number"
                  :error-name="`${lastFourYears} %`"
                  rules="required|max-value"
                  :readonly="isReadonly"
                />
              </b-col>
              <b-col md="6">
                <InputField
                  id="rate-2022"
                  v-model="consumerCreditFormData.customerProportionThreeYearsAgo"
                  :label="`${lastThreeYears} (%)`"
                  placeholder="Enter rate"
                  type="number"
                  :error-name="`${lastThreeYears} %`"
                  rules="required|max-value"
                  :readonly="isReadonly"
                />
              </b-col>
              <b-col md="6">
                <InputField
                  id="rate-2023"
                  v-model="consumerCreditFormData.customerProportionTwoYearsAgo"
                  :label="`${lastTwoYears} (%)`"
                  placeholder="Enter rate"
                  type="number"
                  :error-name="`${lastTwoYears} %`"
                  rules="required|max-value"
                  :readonly="isReadonly"
                />
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </tab-content>

      <template
        slot="finish"
      >
        <div class="wizard-footer-right">
          <Button
            v-if="actionType === 'add'"
            :label="buttonTitle"
            :loading="isLoading"
            :disabled="isDisabled"
            size="lg"
            @click="handleSubmit"
          />
        </div>

      </template>
      <!-- Display Validation Errors -->
      <b-modal
        id="all-validated-modal"
        ref="allValidatedModal"
        ok-title="Cancel"
        ok-only
        no-close-on-backdrop
        ok-variant="outline-secondary"
        centered
        size="md"
        title="Kindly attend to the field(s) below"
        @hidden="resetValidationModal"
      >
        <div
          v-for="(errorItem, index) in allValidationErrors"
          :key="index"
        >
          <p>{{ `${index + 1}.` }} <span style="color: red;"> {{ errorItem }}</span></p>
        </div>
      </b-modal>
      <!-- Display Validation Errors -->
      <FullScreenSpinner :show="showSpinner" />
    </form-wizard>
    <!-- </div> -->
  </div>
</template>

<script>
import {
  BRow, BCol, BForm,
} from 'bootstrap-vue'
import { FormWizard, TabContent } from 'vue-form-wizard'
import { ValidationObserver } from 'vee-validate'
import { sweetAlert } from '@core/mixins/sweetAlert'
import { required } from '@validations'
import { modalMixins } from '@core/mixins/modal'
import { tableMixins } from '@core/mixins/table'
import Ripple from 'vue-ripple-directive'
import { mapActions } from 'vuex'
import { permissionMixin } from '@core/mixins/permission'
import DatePickerField from '../DatePickerField.vue'
import InputField from '../InputField.vue'
import InputNumberField from '../InputNumberField.vue'
import SelectField from '../SelectField.vue'
import FullScreenSpinner from '@/views/components/spinner/FullScreenSpinner.vue'
import { formatAmount, toKobo, toBalance } from '@/helpers/formatAmount'
import addSpaceToString from '@/helpers/addSpaceToString'

import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import Button from '../../components/button/Button.vue'
import {
  daysOptions, monthsOptions, yearsOptions, countries,
} from '@/helpers/data'
import { lmsPermissions } from '@/helpers/permissions'

const currentYear = new Date().getFullYear()
const lastFourYears = currentYear - 4
const lastThreeYears = currentYear - 3
const lastTwoYears = currentYear - 2

export default {
  name: 'PFIOnboardingForm',
  components: {
    BRow,
    BCol,
    FormWizard,
    TabContent,
    BForm,
    ValidationObserver,
    InputField,
    InputNumberField,
    SelectField,
    Button,
    FullScreenSpinner,
    DatePickerField,
  },
  directives: {
    Ripple,
  },
  mixins: [modalMixins, tableMixins, sweetAlert, permissionMixin],
  props: {
    isEdit: {
      type: Boolean,
      default: false,
    },
    initialFormData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      lastFourYears,
      lastThreeYears,
      lastTwoYears,
      daysOptions,
      monthsOptions,
      yearsOptions: yearsOptions(),
      showBackButton: false,
      pfiOnboardingEmail: true,
      showSearchEmail: false,
      addSpaceToString,
      toBalance,
      isReadonly: false,
      isBusy: false,
      showSpinner: false,
      isDisabled: false,
      isLoading: false,
      buttonTitle: 'Submit',
      required,
      formatAmount,
      rules: '',
      actionType: 'add',
      actionCategory: '',
      country: '',
      lgaOptions: [],
      fiTypesOptions: [
        { value: 'CommercialBank', label: 'Commercial Banks' },
        { value: 'MerchantBank', label: 'Merchant Bank' },
        { value: 'DiscountHouse', label: 'Discount House' },
        { value: 'PrimaryMortgageInstituition', label: 'Primary Mortgage Instituition' },
        { value: 'FinanceCompany', label: 'Finance Company' },
        { value: 'DevelopmentFinancialInstitution', label: 'Development Financial Institution' },
        { value: 'MicroFinanceBank', label: 'Micro Finance Bank' },
      ],
      classOfCommercialBanksOptions: [
        { value: 'SystematicallyImportant', label: 'Systematically Important' },
        { value: 'International', label: 'International' },
        { value: 'National', label: 'National' },
        { value: 'Regional', label: 'Regional' },
        { value: 'Others', label: 'Others' },
      ],
      classOfMFBOptions: [
        { value: 'Unit', label: 'Unit' },
        { value: 'State', label: 'State' },
        { value: 'National', label: 'National' },
      ],
      yesNoOptions: [
        { value: 'Yes', label: 'Yes' },
        { value: 'No', label: 'No' },
      ],
      creditProductTypeOptions: [
        { value: 'Wholesale lending', label: 'Wholesale lending' },
        { value: 'Credit guarantees', label: 'Credit guarantees' },
      ],
      averageProductTenorOptions: [
        { value: '1', label: '1' },
        { value: '2', label: '2' },
        { value: '3', label: '3' },
        { value: '4', label: '4' },
        { value: '5', label: '5' },
        { value: '> 5', label: '> 5' },
      ],
      creditRelationshipNumberOptions: [
        { value: '1', label: '1' },
        { value: '2', label: '2' },
        { value: '3', label: '3' },
        { value: '4', label: '4' },
      ],
      ratingOptions: [
        { value: 'Low', label: 'Low' },
        { value: 'Moderate', label: 'Moderate' },
        { value: 'AboveAverage', label: 'Above Average' },
        { value: 'High', label: 'High' },
      ],
      riskReviewFrequentOptions: [
        { value: 'Monthly', label: 'Monthly' },
        { value: 'Quarterly', label: 'Quarterly' },
        { value: 'SemiAnnual', label: 'Semi-Annual' },
        { value: 'Yearly', label: 'Yearly' },
        { value: 'EveryTwoYears', label: 'Every Two Years' },
        { value: 'EveryThreeYears', label: 'Every Three Years' },
      ],
      bankRiskAppetiteOptions: [
        { value: 'VeryHigh', label: 'Very High' },
        { value: 'High', label: 'High' },
        { value: 'Medium', label: 'Medium' },
        { value: 'Low', label: 'Low' },
        { value: 'VeryLow', label: 'Very Low' },
      ],
      complianceLevelOptions: [
        { value: 'High', label: 'High' },
        { value: 'Medium', label: 'Medium' },
        { value: 'Low', label: 'Low' },
      ],
      moneyLaundryComplianceLevelOptions: [
        { value: 'FullCompliance', label: 'Full Compliance' },
        { value: 'PartialCompliance', label: 'Partial Compliance' },
        { value: 'NoCompliance', label: 'No Compliance' },
        { value: 'NotApplicable', label: 'Not Applicable' },
      ],
      successLevelOptions: [
        { value: 'VerySuccessful', label: 'Very Successful' },
        { value: 'NotTooSuccessful', label: 'Not Too Successful' },
        { value: 'NotSuccessful', label: 'Not Successful' },
      ],
      creditBureauOptions: [
        { value: 'CRC', label: 'CRC' },
        { value: 'XDS', label: 'XDS' },
        { value: 'CRServices', label: 'CR Services' },
        { value: 'Equifax', label: 'Equifax' },
      ],
      datePickerConfig: {
        dateFormat: 'Y-m-d',
        maxDate: 'today',
        ariaDateFormat: 'Y-m-d',
      },
      userFormData: {
        email: '',
      },
      backgroundInfoFormData: {
        institutionName: '',
        institutionEmail: '',
        fullName: '',
        contactEmailAddress: '',
        contactPhoneNumber: '',
        institutionAddress: '',
        city: '',
        state: '',
        localGovernmentArea: '',
        shareholdersFund: 0,
        operatingLicenseIssueDate: null,
        licenseNumber: '',
        operationCommencementDate: null,
        financialInstitutionType: '',
        commercialBankType: '',
        microFinanceBankType: '',
        branchCount: 0,
        creditProductOutletCount: 0,
        hasRegulatoryExceptions: false,
        regulatoryExceptions: '',
        riskManagement: '',
        hasRiskManagementFramework: false,
        hasCreditBureauRelationships: false,
        creditBureauRelationshipsCount: 0,
        creditBureaus: [],
        preferredCreditProducts: '',
        creditExtendedAmountFourYearsAgo: 0,
        creditExtendedAmountThreeYearsAgo: 0,
        creditExtendedAmountTwoYearsAgo: 0,
        averageProductTenor: '',
        averageInterestRate: '',
      },
      profitabilityRequirementFormData: {
        pbtFigureFourYearsAgo: null,
        pbtFigureThreeYearsAgo: null,
        pbtFigureTwoYearsAgo: null,
        capitalAdequacyRatioFourYearsAgo: null,
        capitalAdequacyRatioThreeYearsAgo: null,
        capitalAdequacyRatioTwoYearsAgo: null,
        liquidityRatioFourYearsAgo: null,
        liquidityRatioThreeYearsAgo: null,
        liquidityRatioTwoYearsAgo: null,
        nplRatioFourYearsAgo: null,
        nplRatioThreeYearsAgo: null,
        nplRatioTwoYearsAgo: null,
        consumerCreditNplRatioFourYearsAgo: null,
        consumerCreditNplRatioThreeYearsAgo: null,
        consumerCreditNplRatioTwoYearsAgo: null,
      },
      riskManagementFormData: {
        hasRiskManagementFramework: null,
        riskReviewFrequency: null,
        hasRiskAppetiteFramework: null,
        riskAppetiteDescription: null,
        hasRiskMonitoringMeasures: null,
        rIskRatingLastTwoYears: null,
        rIskRatingLastYear: null,
        rIskRatingValueLastTwoYears: null,
        rIskRatingValueLastYear: null,
      },
      regulatoryFormData: {
        complianceLevel: null,
        hasRegulatoryBreaches: null,
        hasComplianceFramework: null,
        hasAmlCftPolicies: null,
        moneyLaunderingActComplianceLevel: null,
        kycComplianceMeasures: null,
        nsrpComplianceLevel: null,
      },
      consumerCreditFormData: {
        debtServiceRatio: null,
        creditworthinessAssessmentMethod: '',
        productSuccessRating: null,
        customerCountFourYearsAgo: null,
        customerCountThreeYearsAgo: null,
        customerCountTwoYearsAgo: null,
        customerProportionFourYearsAgo: null,
        customerProportionThreeYearsAgo: null,
        customerProportionTwoYearsAgo: null,
      },
      profileReference: '',
      currentStage: '',
      allValidationErrors: [],
    }
  },
  computed: {
    stateOptions() {
      const country = countries.find(item => item.name === 'Nigeria')
      return country.states.map(item => item.state).sort()
    },
  },
  watch: {
    isEdit: {
      immediate: true,
      handler(val) {
        this.isReadonly = val
      },
    },
    initialFormData: {
      immediate: true,
      deep: true,
      handler(newValue) {
        try {
          if (Object.keys(newValue).length) {
            this.backgroundInfoFormData = {
              ...this.backgroundInfoFormData,
              ...newValue.backgroundInformation,
              contactEmailAddress: newValue.contactInfo[0].emailAddress,
              contactPhoneNumber: newValue.contactInfo[0].contactPhoneNumber,
              fullName: newValue.contactInfo[0].fullName,
              creditExtendedAmountFourYearsAgo: toBalance(newValue.backgroundInformation.creditExtendedAmountFourYearsAgo),
              creditExtendedAmountThreeYearsAgo: toBalance(newValue.backgroundInformation.creditExtendedAmountThreeYearsAgo),
              creditExtendedAmountTwoYearsAgo: toBalance(newValue.backgroundInformation.creditExtendedAmountTwoYearsAgo),
              shareholdersFund: toBalance(newValue.backgroundInformation.shareholdersFund),
              operatingLicenseIssueDate: newValue.backgroundInformation.operatingLicenseIssueDate,
              operationCommencementDate: newValue.backgroundInformation.operationCommencementDate,
            }

            this.profitabilityRequirementFormData = {
              ...this.profitabilityRequirementFormData,
              ...newValue.profitabilityRequirements,
              pbtFigureFourYearsAgo: toBalance(newValue.profitabilityRequirements.pbtFigureFourYearsAgo),
              pbtFigureThreeYearsAgo: toBalance(newValue.profitabilityRequirements.pbtFigureThreeYearsAgo),
              pbtFigureTwoYearsAgo: toBalance(newValue.profitabilityRequirements.pbtFigureTwoYearsAgo),
            }

            this.riskManagementFormData = {
              ...this.riskManagementFormData,
              ...newValue.riskManagement,
            }

            this.regulatoryFormData = {
              ...this.regulatoryFormData,
              ...newValue.compliance,
            }

            this.consumerCreditFormData = {
              ...this.consumerCreditFormData,
              ...newValue.consumerCreditSector,
              customerCountFourYearsAgo: toBalance(newValue.consumerCreditSector.customerCountFourYearsAgo),
              customerCountThreeYearsAgo: toBalance(newValue.consumerCreditSector.customerCountThreeYearsAgo),
              customerCountTwoYearsAgo: toBalance(newValue.consumerCreditSector.customerCountTwoYearsAgo),
            }
            this.$refs.pfiOboardingFormRef.activateAll()
          }
        } catch (error) {
          //  console.log({ error })
        }
      },
    },
    backgroundInfoFormData: {
      handler() {
        this.emitFormUpdate()
      },
      deep: true,
    },
    profitabilityRequirementFormData: {
      handler() {
        this.emitFormUpdate()
      },
      deep: true,
    },
    riskManagementFormData: {
      handler() {
        this.emitFormUpdate()
      },
      deep: true,
    },
    regulatoryFormData: {
      handler() {
        this.emitFormUpdate()
      },
      deep: true,
    },
    consumerCreditFormData: {
      handler() {
        this.emitFormUpdate()
      },
      deep: true,
    },
  },
  mounted() {
    const { type, cat, emailAddress } = this.$route.params
    this.actionType = type
    this.actionCategory = cat

    if (this.actionType === 'edit' || this.actionType === 'view') {
      this.showSpinner = true
      this.showSearchEmail = true
      this.buttonTitle = 'Update'
      this.getPfiOnboadringDetails()
    }
    if (this.actionType === 'add' && this.actionCategory === 'resume') {
      this.userFormData.email = emailAddress
      this.resumePfiOnboarding()
    }
  },
  methods: {
    ...mapActions({
      getPFIOnboardingInitialize: 'account/getPFIOnboardingInitialize',
      createPfiOnboarding: 'account/createPfiOnboardingAction',
      createPfiOnboardingAll: 'account/createPfiOnboardingAllAction',
      updatePfiOnboarding: 'account/updatePfiOnboardingAction',
      fetchPfiOnboardingDetails: 'account/fetchPfiOnboardingDetails',
    }),
    emitFormUpdate() {
      const formData = this.getFormData()
      this.$emit('update', {
        formData: { ...formData },
      })
    },
    resetCreditBureau(value) {
      if (value) {
        this.backgroundInfoFormData.creditBureaus = []
      }
    },
    limitSelection(selected) {
      if (selected.length > this.backgroundInfoFormData.creditBureauRelationshipsCount) {
        selected.pop() // Remove the last selected option
      }
      this.backgroundInfoFormData.creditBureaus = selected
    },
    getLGAByState(selectedValue) {
      this.backgroundInfoFormData.localGovernmentArea = ''
      const country = countries.find(item => item.name === 'Nigeria')
      const selectedState = country.states.find(item => item.state === selectedValue)
      this.lgaOptions = selectedState.lgas.sort()
    },
    resumePfiOnboarding() {
      this.pfiOnboardingEmail = false
      this.onboardingInitiateAction()
    },
    async handleOnboardingInitial() {
      this.$refs.onboardingInitialRules.validate().then(success => {
        if (success) {
          this.onboardingInitiateAction()
        }
      })
    },
    async onboardingInitiateAction() {
      if (this.userFormData.email !== null) {
        try {
          this.showBackButton = true
          this.isLoading = true
          const formData = {
            ...this.userFormData,
          }
          const response = await this.getPFIOnboardingInitialize({ formData, permission: lmsPermissions.VIEW_PFI_ONBOARDING })

          const { status, data } = await response
          if (status === 200 && data) {
            this.pfiOnboardingEmail = false
            let currentStage
            if (data.currentStage === 'BackgroundInformation') {
              currentStage = 0
            } else if (data.currentStage === 'ProfitabilityRequirements') {
              currentStage = 1
            } else if (data.currentStage === 'RiskManagement') {
              currentStage = 2
            } else if (data.currentStage === 'Compliance') {
              currentStage = 3
            } else {
              currentStage = 4
            }

            this.profileReference = data.profileReference
            this.currentStage = data.currentStage

            this.$nextTick(() => {
              if (this.$refs.pfiOboardingFormRef) {
                this.$refs.pfiOboardingFormRef.activeTabIndex = currentStage
                this.$refs.pfiOboardingFormRef.activateTab(currentStage)
              }
            })

            this.backgroundInfoFormData = {
              ...data.backgroundInformation,
              shareholdersFund: data.backgroundInformation.shareholdersFund ? toBalance(data.backgroundInformation.shareholdersFund) : '',
              contactEmailAddress: data.contactInfo[0].emailAddress,
              contactPhoneNumber: data.contactInfo[0].contactPhoneNumber,
              fullName: data.contactInfo[0].fullName,
              creditExtendedAmountTwoYearsAgo: data.backgroundInformation.creditExtendedAmountTwoYearsAgo ? toBalance(data.backgroundInformation.creditExtendedAmountTwoYearsAgo) : '',
              creditExtendedAmountThreeYearsAgo: data.backgroundInformation.creditExtendedAmountThreeYearsAgo ? toBalance(data.backgroundInformation.creditExtendedAmountThreeYearsAgo) : '',
              creditExtendedAmountFourYearsAgo: data.backgroundInformation.creditExtendedAmountFourYearsAgo ? toBalance(data.backgroundInformation.creditExtendedAmountFourYearsAgo) : '',
              operatingLicenseIssueDate: data.backgroundInformation.operatingLicenseIssueDate,
              operationCommencementDate: data.backgroundInformation.operationCommencementDate,
            }
            this.profitabilityRequirementFormData = {
              ...data.profitabilityRequirements,
              pbtFigureFourYearsAgo: data.profitabilityRequirements.pbtFigureFourYearsAgo ? toBalance(data.profitabilityRequirements.pbtFigureFourYearsAgo) : '',
              pbtFigureThreeYearsAgo: data.profitabilityRequirements.pbtFigureThreeYearsAgo ? toBalance(data.profitabilityRequirements.pbtFigureThreeYearsAgo) : '',
              pbtFigureTwoYearsAgo: data.profitabilityRequirements.pbtFigureTwoYearsAgo ? toBalance(data.profitabilityRequirements.pbtFigureTwoYearsAgo) : '',
            }
            this.riskManagementFormData = {
              ...data.riskManagement,
            }
            this.regulatoryFormData = {
              ...data.compliance,
            }

            this.consumerCreditFormData = {
              ...data.consumerCreditSector,
              customerCountFourYearsAgo: data.consumerCreditSector.customerCountFourYearsAgo ? toBalance(data.consumerCreditSector.customerCountFourYearsAgo) : '',
              customerCountThreeYearsAgo: data.consumerCreditSector.customerCountThreeYearsAgo ? toBalance(data.consumerCreditSector.customerCountThreeYearsAgo) : '',
              customerCountTwoYearsAgo: data.consumerCreditSector.customerCountTwoYearsAgo ? toBalance(data.consumerCreditSector.customerCountTwoYearsAgo) : '',
            }
          }
        } catch (error) {
          error.response.data.errors.forEach(responseError => {
            this.alertError({ text: `${responseError.errorMessage}` })
          })
        } finally {
          this.isLoading = false
        }
      } else {
        this.pfiOnboardingEmail = true
      }
    },
    backNavigationAction() {
      this.showBackButton = true
      this.$router.push({
        name: 'pfi-onboarding-list',
      })
    },
    backNavigationResume() {
      this.showBackButton = true
      this.$router.push({
        name: 'pfi-application',
      })
    },
    resetValidationModal() {
      this.allValidationErrors = []
    },
    handleBackgroundInformation() {
      return new Promise((resolve, reject) => {
        this.$refs.backgroundInfoRules.validate().then(async success => {
          if (success) {
            resolve(true)
            let buttonLabel
            if (this.actionType === 'add') {
              buttonLabel = 'Save'
            } else {
              buttonLabel = 'Update'
            }

            if (this.actionType !== 'view') {
              try {
                this.isLoading = true
                this.showSpinner = true
                const formData = {
                  profileReference: this.profileReference,
                  currentStage: 'BackgroundInformation',
                  backgroundInformation: {
                    institutionName: this.backgroundInfoFormData.institutionName,
                    institutionEmail: this.backgroundInfoFormData.institutionEmail,
                    institutionAddress: this.backgroundInfoFormData.institutionAddress,
                    city: this.backgroundInfoFormData.city,
                    state: this.backgroundInfoFormData.state,
                    localGovernmentArea: this.backgroundInfoFormData.localGovernmentArea,
                    shareholdersFund: toKobo(this.backgroundInfoFormData.shareholdersFund),
                    operatingLicenseIssueDate: this.backgroundInfoFormData.operatingLicenseIssueDate,
                    licenseNumber: this.backgroundInfoFormData.licenseNumber,
                    operationCommencementDate: this.backgroundInfoFormData.operationCommencementDate,
                    financialInstitutionType: this.backgroundInfoFormData.financialInstitutionType,
                    commercialBankType: this.backgroundInfoFormData.commercialBankType,
                    microFinanceBankType: this.backgroundInfoFormData.microFinanceBankType,
                    branchCount: this.backgroundInfoFormData.branchCount,
                    creditProductOutletCount: this.backgroundInfoFormData.creditProductOutletCount,
                    hasRegulatoryExceptions: this.backgroundInfoFormData.hasRegulatoryExceptions,
                    regulatoryExceptions: this.backgroundInfoFormData.regulatoryExceptions,
                    hasRiskManagementFramework: this.backgroundInfoFormData.hasRiskManagementFramework,
                    hasCreditBureauRelationships: this.backgroundInfoFormData.hasCreditBureauRelationships,
                    creditBureauRelationshipsCount: this.backgroundInfoFormData.creditBureauRelationshipsCount,
                    creditBureaus: this.backgroundInfoFormData.creditBureaus,
                    preferredCreditProducts: this.backgroundInfoFormData.preferredCreditProducts,
                    creditExtendedAmountFourYearsAgo: toKobo(this.backgroundInfoFormData.creditExtendedAmountFourYearsAgo),
                    creditExtendedAmountThreeYearsAgo: toKobo(this.backgroundInfoFormData.creditExtendedAmountThreeYearsAgo),
                    creditExtendedAmountTwoYearsAgo: toKobo(this.backgroundInfoFormData.creditExtendedAmountTwoYearsAgo),
                    averageProductTenor: this.backgroundInfoFormData.averageProductTenor,
                    averageInterestRate: this.backgroundInfoFormData.averageInterestRate,
                  },
                  contactInfo: [
                    {
                      emailAddress: this.backgroundInfoFormData.contactEmailAddress,
                      contactPhoneNumber: this.backgroundInfoFormData.contactPhoneNumber,
                      fullName: this.backgroundInfoFormData.fullName,
                    },
                  ],
                }
                const response = (this.actionType === 'add')
                  ? await this.createPfiOnboarding({ formData, permission: lmsPermissions.VIEW_PFI_ONBOARDING })
                  : resolve(true)

                const { status, data } = await response
                if (status === 200 && data) {
                  this.alertSuccess({ text: `Your request to ${buttonLabel} Background Information was successful` })
                  resolve(true)
                }
              } catch (error) {
                if (this.actionType === 'add') {
                  error.response.data.errors.forEach(responseError => {
                    this.alertError({ text: `Request to ${buttonLabel} Background Information Failed. Reason: ${responseError.errorMessage}` })
                  })
                }
              } finally {
                this.isLoading = false
                this.showSpinner = false
              }
            } else {
              resolve(true)
            }
          } else {
            // Get all backgroundInfoRules Errors
            const errorMessages = []
            Object.keys(this.$refs.backgroundInfoRules.errors).forEach(key => {
              const value = this.$refs.backgroundInfoRules.errors[key]

              if (Array.isArray(value) && value.length > 0) {
                value.forEach(error => {
                  errorMessages.push(`${error}`)
                })
              }
            })
            this.allValidationErrors = errorMessages
            this.$root.$emit('bv::show::modal', 'all-validated-modal')
            reject()
          }
        })
        this.emitFormUpdate()
      })
    },
    validateProfitabilityRequirement() {
      return new Promise((resolve, reject) => {
        this.$refs.profitabilityRequirementRules.validate().then(async success => {
          if (success) {
            resolve(true)
            let buttonLabel
            if (this.actionType === 'add') {
              buttonLabel = 'Save'
            } else {
              buttonLabel = 'Update'
            }

            if (this.actionType !== 'view') {
              try {
                this.isLoading = true
                this.showSpinner = true
                const formData = {
                  profileReference: this.profileReference,
                  currentStage: 'ProfitabilityRequirements',

                  profitabilityRequirements: {
                    pbtFigureFourYearsAgo: toKobo(this.profitabilityRequirementFormData.pbtFigureFourYearsAgo),
                    pbtFigureThreeYearsAgo: toKobo(this.profitabilityRequirementFormData.pbtFigureThreeYearsAgo),
                    pbtFigureTwoYearsAgo: toKobo(this.profitabilityRequirementFormData.pbtFigureTwoYearsAgo),
                    capitalAdequacyRatioFourYearsAgo: this.profitabilityRequirementFormData.capitalAdequacyRatioFourYearsAgo,
                    capitalAdequacyRatioThreeYearsAgo: this.profitabilityRequirementFormData.capitalAdequacyRatioThreeYearsAgo,
                    capitalAdequacyRatioTwoYearsAgo: this.profitabilityRequirementFormData.capitalAdequacyRatioTwoYearsAgo,
                    liquidityRatioFourYearsAgo: this.profitabilityRequirementFormData.liquidityRatioFourYearsAgo,
                    liquidityRatioThreeYearsAgo: this.profitabilityRequirementFormData.liquidityRatioThreeYearsAgo,
                    liquidityRatioTwoYearsAgo: this.profitabilityRequirementFormData.liquidityRatioTwoYearsAgo,
                    nplRatioFourYearsAgo: this.profitabilityRequirementFormData.nplRatioFourYearsAgo,
                    nplRatioThreeYearsAgo: this.profitabilityRequirementFormData.nplRatioThreeYearsAgo,
                    nplRatioTwoYearsAgo: this.profitabilityRequirementFormData.nplRatioTwoYearsAgo,
                    consumerCreditNplRatioFourYearsAgo: this.profitabilityRequirementFormData.consumerCreditNplRatioFourYearsAgo,
                    consumerCreditNplRatioThreeYearsAgo: this.profitabilityRequirementFormData.consumerCreditNplRatioThreeYearsAgo,
                    consumerCreditNplRatioTwoYearsAgo: this.profitabilityRequirementFormData.consumerCreditNplRatioTwoYearsAgo,
                  },
                }
                const response = (this.actionType === 'add')
                  ? await this.createPfiOnboarding({ formData, permission: lmsPermissions.VIEW_PFI_ONBOARDING })
                  : resolve(true)

                const { status, data } = await response
                if (status === 200 && data) {
                  this.alertSuccess({ text: `Your request to ${buttonLabel} Profitability Requirements was successful` })
                  resolve(true)
                }
              } catch (error) {
                if (this.actionType === 'add') {
                  error.response.data.errors.forEach(responseError => {
                    this.alertError({ text: `Request to ${buttonLabel} Profitability Requirements Failed. Reason: ${responseError.errorMessage}` })
                  })
                }
              } finally {
                this.isLoading = false
                this.showSpinner = false
              }
            } else {
              resolve(true)
            }
          } else {
            // Get all profitabilityRequirementRules Errors
            const errorMessages = []
            Object.keys(this.$refs.profitabilityRequirementRules.errors).forEach(key => {
              const value = this.$refs.profitabilityRequirementRules.errors[key]

              if (Array.isArray(value) && value.length > 0) {
                value.forEach(error => {
                  errorMessages.push(`${error}`)
                })
              }
            })
            this.allValidationErrors = errorMessages
            this.$root.$emit('bv::show::modal', 'all-validated-modal')
            reject()
          }
        })
        this.emitFormUpdate()
      })
    },
    validateRiskManagementPractices() {
      return new Promise((resolve, reject) => {
        this.$refs.riskManagementPracticesRules.validate().then(async success => {
          if (success) {
            resolve(true)
            let buttonLabel
            if (this.actionType === 'add') {
              buttonLabel = 'Save'
            } else {
              buttonLabel = 'Update'
            }

            if (this.actionType !== 'view') {
              try {
                this.isLoading = true
                this.showSpinner = true
                const formData = {
                  profileReference: this.profileReference,
                  currentStage: 'RiskManagement',

                  riskManagement: {
                    hasRiskManagementFramework: this.riskManagementFormData.hasRiskManagementFramework,
                    riskReviewFrequency: this.riskManagementFormData.riskReviewFrequency,
                    hasRiskAppetiteFramework: this.riskManagementFormData.hasRiskAppetiteFramework,
                    riskAppetiteDescription: this.riskManagementFormData.riskAppetiteDescription,
                    hasRiskMonitoringMeasures: this.riskManagementFormData.hasRiskMonitoringMeasures,
                    rIskRatingLastTwoYears: this.riskManagementFormData.rIskRatingLastTwoYears,
                    rIskRatingLastYear: this.riskManagementFormData.rIskRatingLastYear,
                    rIskRatingValueLastTwoYears: this.riskManagementFormData.rIskRatingValueLastTwoYears,
                    rIskRatingValueLastYear: this.riskManagementFormData.rIskRatingValueLastYear,
                  },
                }
                const response = (this.actionType === 'add')
                  ? await this.createPfiOnboarding({ formData, permission: lmsPermissions.VIEW_PFI_ONBOARDING })
                  : resolve(true)

                const { status, data } = await response
                if (status === 200 && data) {
                  this.alertSuccess({ text: `Your request to ${buttonLabel} Risk Management Practices was successful` })
                  resolve(true)
                }
              } catch (error) {
                if (this.actionType === 'add') {
                  error.response.data.errors.forEach(responseError => {
                    this.alertError({ text: `Request to ${buttonLabel} Risk Management Practices Failed. Reason: ${responseError.errorMessage}` })
                  })
                }
              } finally {
                this.isLoading = false
                this.showSpinner = false
              }
            } else {
              resolve(true)
            }
          } else {
            // Get all riskManagementPracticesRules Errors
            const errorMessages = []
            Object.keys(this.$refs.riskManagementPracticesRules.errors).forEach(key => {
              const value = this.$refs.riskManagementPracticesRules.errors[key]

              if (Array.isArray(value) && value.length > 0) {
                value.forEach(error => {
                  errorMessages.push(`${error}`)
                })
              }
            })
            this.allValidationErrors = errorMessages
            this.$root.$emit('bv::show::modal', 'all-validated-modal')
            reject()
          }
        })
        this.emitFormUpdate()
      })
    },
    validateRegulatoryCompliance() {
      return new Promise((resolve, reject) => {
        this.$refs.regulatoryComplianceRules.validate().then(async success => {
          if (success) {
            resolve(true)
            let buttonLabel
            if (this.actionType === 'add') {
              buttonLabel = 'Save'
            } else {
              buttonLabel = 'Update'
            }

            if (this.actionType !== 'view') {
              try {
                this.isLoading = true
                this.showSpinner = true
                const formData = {
                  profileReference: this.profileReference,
                  currentStage: 'Compliance',

                  compliance: {
                    complianceLevel: this.regulatoryFormData.complianceLevel,
                    hasRegulatoryBreaches: this.regulatoryFormData.hasRegulatoryBreaches,
                    hasComplianceFramework: this.regulatoryFormData.hasComplianceFramework,
                    hasAmlCftPolicies: this.regulatoryFormData.hasAmlCftPolicies,
                    moneyLaunderingActComplianceLevel: this.regulatoryFormData.moneyLaunderingActComplianceLevel,
                    kycComplianceMeasures: this.regulatoryFormData.kycComplianceMeasures,
                    nsrpComplianceLevel: this.regulatoryFormData.nsrpComplianceLevel,
                  },
                }
                const response = (this.actionType === 'add')
                  ? await this.createPfiOnboarding({ formData, permission: lmsPermissions.VIEW_PFI_ONBOARDING })
                  : resolve(true)

                const { status, data } = await response
                if (status === 200 && data) {
                  this.alertSuccess({ text: `Your request to ${buttonLabel} Regulatory Compliance was successful` })
                  resolve(true)
                }
              } catch (error) {
                if (this.actionType === 'add') {
                  error.response.data.errors.forEach(responseError => {
                    this.alertError({ text: `Request to ${buttonLabel} Regulatory Compliance Failed. Reason: ${responseError.errorMessage}` })
                  })
                }
              } finally {
                this.isLoading = false
                this.showSpinner = false
              }
            } else {
              resolve(true)
            }
          } else {
            // Get all regulatoryComplianceRules Errors
            const errorMessages = []
            Object.keys(this.$refs.regulatoryComplianceRules.errors).forEach(key => {
              const value = this.$refs.regulatoryComplianceRules.errors[key]

              if (Array.isArray(value) && value.length > 0) {
                value.forEach(error => {
                  errorMessages.push(`${error}`)
                })
              }
            })
            this.allValidationErrors = errorMessages
            this.$root.$emit('bv::show::modal', 'all-validated-modal')
            reject()
          }
        })
        this.emitFormUpdate()
      })
    },
    getFormData() {
      const formData = {
        profileReference: this.profileReference,
        emailAddress: this.backgroundInfoFormData.contactEmailAddress,
        institutionName: this.backgroundInfoFormData.institutionName,
        institutionEmail: this.backgroundInfoFormData.institutionEmail,

        backgroundInformation: {
          institutionName: this.backgroundInfoFormData.institutionName,
          institutionEmail: this.backgroundInfoFormData.institutionEmail,
          institutionAddress: this.backgroundInfoFormData.institutionAddress,
          city: this.backgroundInfoFormData.city,
          state: this.backgroundInfoFormData.state,
          localGovernmentArea: this.backgroundInfoFormData.localGovernmentArea,
          shareholdersFund: toKobo(this.backgroundInfoFormData.shareholdersFund),
          operatingLicenseIssueDate: this.backgroundInfoFormData.operatingLicenseIssueDate,
          licenseNumber: this.backgroundInfoFormData.licenseNumber,
          operationCommencementDate: this.backgroundInfoFormData.operationCommencementDate,
          financialInstitutionType: this.backgroundInfoFormData.financialInstitutionType,
          commercialBankType: this.backgroundInfoFormData.commercialBankType,
          microFinanceBankType: this.backgroundInfoFormData.microFinanceBankType,
          branchCount: this.backgroundInfoFormData.branchCount,
          creditProductOutletCount: this.backgroundInfoFormData.creditProductOutletCount,
          hasRegulatoryExceptions: this.backgroundInfoFormData.hasRegulatoryExceptions,
          regulatoryExceptions: this.backgroundInfoFormData.regulatoryExceptions,
          hasRiskManagementFramework: this.backgroundInfoFormData.hasRiskManagementFramework,
          hasCreditBureauRelationships: this.backgroundInfoFormData.hasCreditBureauRelationships,
          creditBureauRelationshipsCount: this.backgroundInfoFormData.creditBureauRelationshipsCount,
          creditBureaus: this.backgroundInfoFormData.creditBureaus,
          preferredCreditProducts: this.backgroundInfoFormData.preferredCreditProducts,
          creditExtendedAmountFourYearsAgo: toKobo(this.backgroundInfoFormData.creditExtendedAmountFourYearsAgo),
          creditExtendedAmountThreeYearsAgo: toKobo(this.backgroundInfoFormData.creditExtendedAmountThreeYearsAgo),
          creditExtendedAmountTwoYearsAgo: toKobo(this.backgroundInfoFormData.creditExtendedAmountTwoYearsAgo),
          averageProductTenor: this.backgroundInfoFormData.averageProductTenor,
          averageInterestRate: this.backgroundInfoFormData.averageInterestRate,
        },
        contactInfo: [
          {
            emailAddress: this.backgroundInfoFormData.contactEmailAddress,
            contactPhoneNumber: this.backgroundInfoFormData.contactPhoneNumber,
          },
        ],
        profitabilityRequirements: {
          pbtFigureFourYearsAgo: toKobo(this.profitabilityRequirementFormData.pbtFigureFourYearsAgo),
          pbtFigureThreeYearsAgo: toKobo(this.profitabilityRequirementFormData.pbtFigureThreeYearsAgo),
          pbtFigureTwoYearsAgo: toKobo(this.profitabilityRequirementFormData.pbtFigureTwoYearsAgo),
          capitalAdequacyRatioFourYearsAgo: this.profitabilityRequirementFormData.capitalAdequacyRatioFourYearsAgo,
          capitalAdequacyRatioThreeYearsAgo: this.profitabilityRequirementFormData.capitalAdequacyRatioThreeYearsAgo,
          capitalAdequacyRatioTwoYearsAgo: this.profitabilityRequirementFormData.capitalAdequacyRatioTwoYearsAgo,
          liquidityRatioFourYearsAgo: this.profitabilityRequirementFormData.liquidityRatioFourYearsAgo,
          liquidityRatioThreeYearsAgo: this.profitabilityRequirementFormData.liquidityRatioThreeYearsAgo,
          liquidityRatioTwoYearsAgo: this.profitabilityRequirementFormData.liquidityRatioTwoYearsAgo,
          nplRatioFourYearsAgo: this.profitabilityRequirementFormData.nplRatioFourYearsAgo,
          nplRatioThreeYearsAgo: this.profitabilityRequirementFormData.nplRatioThreeYearsAgo,
          nplRatioTwoYearsAgo: this.profitabilityRequirementFormData.nplRatioTwoYearsAgo,
          consumerCreditNplRatioFourYearsAgo: this.profitabilityRequirementFormData.consumerCreditNplRatioFourYearsAgo,
          consumerCreditNplRatioThreeYearsAgo: this.profitabilityRequirementFormData.consumerCreditNplRatioThreeYearsAgo,
          consumerCreditNplRatioTwoYearsAgo: this.profitabilityRequirementFormData.consumerCreditNplRatioTwoYearsAgo,
        },
        riskManagement: {
          hasRiskManagementFramework: this.riskManagementFormData.hasRiskManagementFramework,
          riskReviewFrequency: this.riskManagementFormData.riskReviewFrequency,
          hasRiskAppetiteFramework: this.riskManagementFormData.hasRiskAppetiteFramework,
          riskAppetiteDescription: this.riskManagementFormData.riskAppetiteDescription,
          hasRiskMonitoringMeasures: this.riskManagementFormData.hasRiskMonitoringMeasures,
          rIskRatingLastTwoYears: this.riskManagementFormData.rIskRatingLastTwoYears,
          rIskRatingLastYear: this.riskManagementFormData.rIskRatingLastYear,
          rIskRatingValueLastTwoYears: this.riskManagementFormData.rIskRatingValueLastTwoYears,
          rIskRatingValueLastYear: this.riskManagementFormData.rIskRatingValueLastYear,
        },
        compliance: {
          complianceLevel: this.regulatoryFormData.complianceLevel,
          hasRegulatoryBreaches: this.regulatoryFormData.hasRegulatoryBreaches,
          hasComplianceFramework: this.regulatoryFormData.hasComplianceFramework,
          hasAmlCftPolicies: this.regulatoryFormData.hasAmlCftPolicies,
          moneyLaunderingActComplianceLevel: this.regulatoryFormData.moneyLaunderingActComplianceLevel,
          kycComplianceMeasures: this.regulatoryFormData.kycComplianceMeasures,
          nsrpComplianceLevel: this.regulatoryFormData.nsrpComplianceLevel,
        },

        consumerCreditSector: {
          debtServiceRatio: this.consumerCreditFormData.debtServiceRatio,
          creditworthinessAssessmentMethod: this.consumerCreditFormData.creditworthinessAssessmentMethod,
          productSuccessRating: this.consumerCreditFormData.productSuccessRating,
          customerCountFourYearsAgo: toKobo(this.consumerCreditFormData.customerCountFourYearsAgo),
          customerCountThreeYearsAgo: toKobo(this.consumerCreditFormData.customerCountThreeYearsAgo),
          customerCountTwoYearsAgo: toKobo(this.consumerCreditFormData.customerCountTwoYearsAgo),
          customerProportionFourYearsAgo: this.consumerCreditFormData.customerProportionFourYearsAgo,
          customerProportionThreeYearsAgo: this.consumerCreditFormData.customerProportionThreeYearsAgo,
          customerProportionTwoYearsAgo: this.consumerCreditFormData.customerProportionTwoYearsAgo,
        },
      }
      return formData
    },
    async handleSubmit() {
      this.$refs.consumerCreditSectorRules.validate().then(async success => {
        if (success) {
          let buttonLabel
          if (this.actionType === 'add') {
            buttonLabel = 'Save'
          } else {
            buttonLabel = 'Update'
          }

          if (this.actionType !== 'view') {
            try {
              this.showSpinner = true
              this.isLoading = true
              this.isDisabled = true
              const formData = this.getFormData()
              const { id } = this.$route.params
              const formUpdate = {
                ...formData,
                institutionEmail: this.backgroundInfoFormData.institutionEmail,
                id,
              }
              const response = this.actionType === 'add'
                ? await this.createPfiOnboardingAll({ formData, permission: lmsPermissions.ADD_PFI_ONBOARDING })
                : await this.updatePfiOnboarding({ formUpdate, permission: lmsPermissions.MODIFY_PFI_ONBOARDING })

              const { status, data } = await response
              if (status === 200 && data) {
                this.alertSuccess({ text: `Your request to ${buttonLabel} PFI Onboarding was successful` })
                this.showSpinner = false
                this.$router.push({ name: 'pfi-onboarding-list' })
              }
            } catch (error) {
              error.response.data.errors.forEach(responseError => {
                this.alertError({ text: `Request to ${buttonLabel} PFI Onboarding Failed. Reason: ${responseError.errorMessage}` })
              })
            } finally {
              this.isLoading = false
              this.isDisabled = false
              this.showSpinner = false
            }
          }
        } else {
          // Get all consumerCreditSectorRules Errors
          const errorMessages = []
          Object.keys(this.$refs.consumerCreditSectorRules.errors).forEach(key => {
            const value = this.$refs.consumerCreditSectorRules.errors[key]

            if (Array.isArray(value) && value.length > 0) {
              value.forEach(error => {
                errorMessages.push(`${error}`)
              })
            }
          })
          this.allValidationErrors = errorMessages
          this.$root.$emit('bv::show::modal', 'all-validated-modal')
        }
      })
    },
    async getPfiOnboadringDetails() {
      try {
        const { id, type } = this.$route.params
        if (id !== undefined) {
          this.actionType = type
          this.isReadonly = type !== 'edit'
          this.showSearchEmail = true
          this.pfiOnboardingEmail = false
          this.showSpinner = true
          this.showBackButton = true

          const response = await this.fetchPfiOnboardingDetails({ id, permission: lmsPermissions.VIEW_PFI_ONBOARDING })
          const { data, status } = response
          if (status === 200) {
            this.backgroundInfoFormData = {
              ...data.backgroundInformation,
              shareholdersFund: data.backgroundInformation.shareholdersFund ? toBalance(data.backgroundInformation.shareholdersFund) : '',
              creditExtendedAmountFourYearsAgo: data.backgroundInformation.creditExtendedAmountFourYearsAgo ? toBalance(data.backgroundInformation.creditExtendedAmountFourYearsAgo) : '',
              creditExtendedAmountThreeYearsAgo: data.backgroundInformation.creditExtendedAmountThreeYearsAgo ? toBalance(data.backgroundInformation.creditExtendedAmountThreeYearsAgo) : '',
              creditExtendedAmountTwoYearsAgo: data.backgroundInformation.creditExtendedAmountTwoYearsAgo ? toBalance(data.backgroundInformation.creditExtendedAmountTwoYearsAgo) : '',
              contactEmailAddress: data.contactInfo[0].emailAddress,
              contactPhoneNumber: data.contactInfo[0].contactPhoneNumber,
              operatingLicenseIssueDate: data.backgroundInformation.operatingLicenseIssueDate,
              operationCommencementDate: data.backgroundInformation.operationCommencementDate,
            }

            this.profitabilityRequirementFormData = {
              ...data.profitabilityRequirements,
              pbtFigureFourYearsAgo: data.profitabilityRequirements.pbtFigureFourYearsAgo ? toBalance(data.profitabilityRequirements.pbtFigureFourYearsAgo) : '',
              pbtFigureThreeYearsAgo: data.profitabilityRequirements.pbtFigureThreeYearsAgo ? toBalance(data.profitabilityRequirements.pbtFigureThreeYearsAgo) : '',
              pbtFigureTwoYearsAgo: data.profitabilityRequirements.pbtFigureTwoYearsAgo ? toBalance(data.profitabilityRequirements.pbtFigureTwoYearsAgo) : '',
            }
            this.riskManagementFormData = {
              ...data.riskManagement,
            }
            this.regulatoryFormData = {
              ...data.compliance,
            }

            this.consumerCreditFormData = {
              ...data.consumerCreditSector,
              customerCountFourYearsAgo: data.consumerCreditSector.customerCountFourYearsAgo ? toBalance(data.consumerCreditSector.customerCountFourYearsAgo) : '',
              customerCountThreeYearsAgo: data.consumerCreditSector.customerCountThreeYearsAgo ? toBalance(data.consumerCreditSector.customerCountThreeYearsAgo) : '',
              customerCountTwoYearsAgo: data.consumerCreditSector.customerCountTwoYearsAgo ? toBalance(data.consumerCreditSector.customerCountTwoYearsAgo) : '',
            }

            this.showSpinner = false
            this.$refs.pfiOboardingFormRef.activateAll()
          }
        }
      } catch (error) {
        this.handleError(error)
      } finally {
        this.showSpinner = false
      }
    },
  },
}
</script>

  <style lang="scss" scoped>
  $primary-color: #0e6934;

  .custom-label-first {
    font-size: 13px;
    color: #666
  }
  .custom-label {
    margin-top: -5px;
    font-size: 13px;
    color: #666
  }
  .custom-label-last {
    margin-bottom: -10px;
    font-size: 13px;
    color: #666
  }
  .custom-header-label {
  color: $primary-color;
  font-size: 15px;
  font-weight: 800;
  margin-bottom: -2px;
  }
  .textDanger {
    color: hsl(0, 86%, 57%) !important;
    margin: -10px 0 10px 20px;
  }
  </style>

  <style lang="scss">
  @import '@core/scss/vue/libs/vue-flatpicker.scss';
  @import '@core/scss/vue/libs/vue-wizard.scss';
  @import '@core/scss/vue/libs/vue-select.scss';
  @import '@core/scss/base/bootstrap-extended/_include.scss';
  </style>
